<template>
  <div class="user-details-container">
    <h1>{{ $t('user.details_title') }}</h1>
    <div class="full-name">
        <div>{{ fullName }}</div>
      </div>  
    <div class="user-data-container">
      <div class="avatar">
        <img :src="avatar" width="200" height="200">
      </div>
      <div class="user-data-1">
        <div> {{ $t('user.first_name').toUpperCase() }} - {{ profile.first_name }}</div>
        <div> {{ $t('user.last_name').toUpperCase() }} - {{ profile.last_name }}</div>
        <div> {{ $t('user.email').toUpperCase() }} - {{ profile.email }}</div>
        <div> {{ $t('user.birthdate').toUpperCase() }} - {{ profile.birthdate }}</div>
      </div>
      <div class="user-data-2">
        <div> {{ $t('user.city').toUpperCase() }} - {{ profile.place }}</div>
        <div> {{ $t('user.date_created').toUpperCase() }} - {{ profile.date_joined }}</div>
        <div> {{ $t('user.user_groups').toUpperCase() }} - {{ profile.user_groups }}</div>
      </div>
    </div>
    <div class="user-records-title">
      <h1>{{ $t('user.recorded_videos') }} ({{ profile.valid_records_amt }} ({{ profile.all_records_amt }})) - {{ $t('user.missions') }} ({{ profile.events_amt }})</h1>
    </div>
    <div class="user-records">
      <user-records :userId="userId" />
    </div>
  </div>
</template>

<script>
// Render a list of users

import UserRepository from '../../repositories/UserRepository.js'
import events from '../../services/events'
import UserRecords from './UserRecords'

export default {
  components: {
    UserRecords
  },
  data () {
    return {
      profile: {}
    }
  },
  mounted () {
    this.fetchUserDetailsData()
  },
  methods: {
    fetchUserDetailsData () {
      let userId = this.userId
      UserRepository.fetchUserDetails(userId).then(data => {
        this.profile = data
        // this.loading = false
      })
      .catch(error => {
        // this.loading = false
        events.emit('error', error)
      })
    }
  },
  computed: {
    fullName () {
      return `${this.profile.first_name} ${this.profile.last_name}`
    },
    avatar () {
      let defaultImg = require('../../assets/img/defaultAvatar.png')
      return this.profile.picture ? this.profile.picture : defaultImg
    },
    userId () {
      return Number(this.$route.params.userId)
    }
  }
}

</script>
